import jQuery from "jquery";

const fn = {
    init: () => {
        fn.setupMap()
    },

    setupMap: () => {

        jQuery(document).ready(function($) {
            let marker = [];
            let map;
            let intervalTime;
            let everyMinute = $('#flexCheckDefault').is(":checked")


            var ambulanceIcon = L.icon({
                iconUrl: '_resources/themes/app/dist/images/ambulance-marker.svg',
                iconSize: [38, 95],
                iconAnchor: [22, 94],
                popupAnchor: [-3, -76],
                // shadowUrl: amicon,
                shadowSize: [68, 95],
                shadowAnchor: [22, 94]
            });
            var fireIcon = L.icon({
                iconUrl: '_resources/themes/app/dist/images/fire-marker.svg',
                iconSize: [38, 95],
                iconAnchor: [22, 94],
                popupAnchor: [-3, -76],
                // shadowUrl: amicon,
                shadowSize: [68, 95],
                shadowAnchor: [22, 94]
            });
            var policeIcon = L.icon({
                iconUrl: '_resources/themes/app/dist/images/police-marker.svg',
                iconSize: [38, 95],
                iconAnchor: [22, 94],
                popupAnchor: [-3, -76],
                // shadowUrl: amicon,
                shadowSize: [68, 95],
                shadowAnchor: [22, 94]
            });

            function getIncidents() {
                $.ajax({
                    type: 'GET',
                    contentType: "application/json",
                    url: "_incidents/incidents",
                    success: async function(res) {
                        let locations = [];
                        let latLong = '';
                        let title = '';
                        let arrayOfLatLngs = [];
                        res.forEach(element => {
                            if (element.Lat != null && element.Lng != null) {

                                title = "<strong>" + element.Title + "</strong>" +
                                    "<br/>" + new Date(element.Date).toLocaleString("en-US") +
                                    "<br/>" + element.Status +
                                    "<br/>" + element.Type +
                                    "<br/>" + element.LocationWithoutStreetNum;
                                locations.push([title, parseFloat(element.Lat), parseFloat(element.Lng), element.Icon]);
                                arrayOfLatLngs.push([parseFloat(element.Lat), parseFloat(element.Lng), element.Icon]);
                                latLong = [parseFloat(element.Lat), parseFloat(element.Lng)]
                            }

                        });
                        setMap(latLong)
                        setMarker(locations, arrayOfLatLngs);
                    }
                });
            }

            function getAcitivityFeedList() {
                $.ajax({
                    type: 'GET',
                    url: "_incidents/getAcitivityFeedList",
                    success: async function(res) {
                        $('#incident-body').empty().html(res);
                    }
                });
            }



            getIncidents();

            function setMap(latLong) {
                map = L.map('map').setView(latLong, 11);

                L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>',
                    subdomains: 'abcd',
                    maxZoom: 20
                }).addTo(map);
            }

            function setMarker(locations, arrayOfLatLngs) {
                if (marker.length != 0) {
                    for (let j = 0; j < marker.length; j++) {
                        map.removeLayer(marker[j]);
                    }
                }
                var bounds = new L.LatLngBounds(arrayOfLatLngs);
                map.fitBounds(bounds);



                for (var i = 0; i < locations.length; i++) {
                    let icon = locations[i][3] == 'fire' ? fireIcon : (locations[i][3] == 'police' ? policeIcon : ambulanceIcon);
                    let popup = L.popup({
                        closeOnClick: false,
                        autoClose: false
                    }).setContent(locations[i][0]);

                    let markerData = new L.marker([locations[i][1], locations[i][2]], { icon: icon })
                        .addTo(map)
                        .bindPopup(popup);
                    marker.push(markerData);

                }
            }

            $(document).on('click', '#refreshNow', function(e) {
                e.preventDefault();
                iniliazeMapAndTable();
            });

            $(document).on('change', '#flexCheckDefault', function(e) {
                e.preventDefault();
                everyMinute = $(this).is(":checked");
                setIntervalTime(everyMinute);
            });

            setIntervalTime(everyMinute);

            function setIntervalTime(everyMinute) {

                if (everyMinute) {
                    intervalTime = setInterval(function() {
                        iniliazeMapAndTable()
                    }, 60 * 1000);
                } else {
                    if (intervalTime != undefined) {
                        clearInterval(intervalTime);
                    }
                }

            }

            function iniliazeMapAndTable() {
                if (map != undefined) {
                    map.remove();
                }
                getIncidents();
                getAcitivityFeedList();
            }

            $(document).on('click', '.leaflet-popup-close-button', function(e) {
                e.preventDefault();
            });

            $(document).on('click', '.viewOnMap', function(e) {
                e.preventDefault();
                let lat = $(this).data('lat');
                let lng = $(this).data('lng');
                $('html, body').animate({
                    scrollTop: $("#map").offset().top - 100
                }, 500);
                if (marker.length !== 0) {
                    for (let k = 0; k < marker.length; k++) {
                        marker[k].closePopup();
                        let latLng = marker[k]._latlng;
                        if (latLng.lat == lat && latLng.lng == lng) {
                            marker[k].openPopup();
                        }
                    }
                }

            });

        });


    }
}

export default {
    can: () => document.querySelector('.pagetype-activityfeedpage'),
    run: fn.init,
}
